import useTranslation from 'next-translate/useTranslation';

import { Translate } from '@core/constant';

import { InputTextControl } from './InputTextControl';
import { InputTextComponentProps, InputTextControlProps } from './interface-form-input';

export const InputLastName = ({
  ...inputProps
}: InputTextComponentProps & Pick<InputTextControlProps, 'label'>): JSX.Element => {
  const { t: tAria } = useTranslation(Translate.common.ARIA);
  const { t: tForm } = useTranslation(Translate.common.FORM);

  return (
    <InputTextControl
      name="lastName"
      aria-label={tAria('lastnameInput')}
      label={tForm('lastName.title')}
      {...inputProps}
    />
  );
};
